import React from 'react';
import { Col, Row } from 'react-bootstrap';

import Button from 'ui-kit/button/button';
import Dialog from 'ui-kit/dialog/dialog';
import BidDisclaimer from 'components/bid-disclaimer/bid-disclaimer.component';

import './style.css';

const BidDisclaimerDialog = ({ bid, onSubmitBidClick, property, ...rest }) => {
    if (!bid) {
        return <div className="no-dialog-content">Whoops, something went wrong..</div>;
    }
    return (
        <Dialog
            className="property-dialog"
            actions={<Button label="Submit Bid" onClick={onSubmitBidClick} />}
            title="Bid Process Disclaimer"
            {...rest}
        >
            <Row>
                <Col xs={12}>
                    <BidDisclaimer />
                </Col>
            </Row>
        </Dialog>
    );
};

export default BidDisclaimerDialog;
